/**
 * Виджет/класс для работы с cookie (аналог $.cookie)
 */
class CookieService {
    // Получить cookie
    static get(name) {
        // экранируем спецсимволы RegExp в уже percent-encoded имени
        const enc = encodeURIComponent(name).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const rx = new RegExp('(^|;)\\s*' + enc + '\\s*=\\s*([^;]+)');
        const m = document.cookie.match(rx);
        return m ? decodeURIComponent(m.pop()) : undefined;
    }
    // Установить cookie
    static set(name, value, days = 365, path = '/') {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=${path}`;
    }
    // Удалить cookie
    static remove(name, path = '/') {
        document.cookie = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=${path}`;
    }
}
if (typeof window !== "undefined") {
    window.CookieService = CookieService;
}

export { CookieService };
